import { useState, useEffect } from 'react'

export const formInputHeight = 42
export const wideFormInput = 400

export const MAX_SIZES = {
    tablet: 768,
    mobile: 480,
}

export function useWindowSize() {
    const isClient = typeof window === 'object'

    function getSize() {
        if (isClient) {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
                device:
                    window.innerWidth > MAX_SIZES['tablet']
                        ? 'pc'
                        : window.innerWidth > MAX_SIZES['mobile']
                        ? 'tablet'
                        : 'mobile',
            }
        }

        return {
            width: undefined,
            height: undefined,
            device: undefined,
        }
    }
    const [windowSize, setWindowSize] = useState(getSize)

    useEffect(() => {
        if (!isClient) {
            return false
        }

        function handleResize() {
            setWindowSize(getSize())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowSize
}

export const useButtonWidth = () => {
    const windowSize = useWindowSize()
    if (windowSize.device === 'pc') {
        return MAX_SIZES['tablet'] / 3
    } else if (windowSize.device === 'tablet') {
        return '100%'
    }
    return '100%'
}

export const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return
            }

            handler(event)
        }

        document.addEventListener('mousedown', listener)
        document.addEventListener('touchstart', listener)

        return () => {
            document.removeEventListener('mousedown', listener)
            document.removeEventListener('touchstart', listener)
        }
    }, [ref, handler])
}
